var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen h-screen flex overflow-hidden layout-bg"},[_c('sidebar',{attrs:{"sidebarVisible":_vm.sidebarVisible},on:{"toggleSidebar":_vm.toggleSidebar}}),_vm._v(" "),_c('div',{staticClass:"flex flex-col w-0 flex-1 overflow-hidden"},[_c('navbar',{on:{"toggleSidebar":_vm.toggleSidebar}}),_vm._v(" "),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }